import {
  Crown,
  Shield,
  Wrench,
  Sparkles,
  Heart,
  Star,
  User,
  type LucideIcon,
} from 'lucide-react';

export const TEAM_ICONS: Record<string, LucideIcon> = {
  crown: Crown,
  shield: Shield,
  wrench: Wrench,
  sparkles: Sparkles,
  heart: Heart,
  star: Star,
  user: User,
};

export const TEAM_ICON_OPTIONS = Object.keys(TEAM_ICONS);

export function getTeamIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Shield;
  return TEAM_ICONS[name] ?? Shield;
}
